var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "report-page content-500" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Report for " + _vm._s(_vm.room.label))
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { name: "form" },
              model: {
                value: _vm.formValid,
                callback: function($$v) {
                  _vm.formValid = $$v
                },
                expression: "formValid"
              }
            },
            [
              _c(
                "table",
                { staticClass: "table table__report" },
                [
                  _c("colgroup", [
                    _c("col"),
                    _vm._v(" "),
                    _c("col"),
                    _vm._v(" "),
                    _c("col", { attrs: { width: "125px" } }),
                    _vm._v(" "),
                    _c("col")
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-left pr-1 pl-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Help")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-left pr-1 pl-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Resource")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-center px-1 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", "justify-space-between": "" } },
                            [
                              _c("strong", { staticClass: "pr-2" }, [
                                _vm._v("Working")
                              ]),
                              _vm._v(" "),
                              _c("strong", { staticClass: "pl-2" }, [
                                _vm._v("Broken")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-center pl-1 pr-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Notes")])]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.inventory, function(field, index) {
                    return [
                      _c(
                        "tr",
                        {
                          key: index,
                          staticClass: "field px-0",
                          attrs: { ripple: "" }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "", "max-width": "350" },
                                  model: {
                                    value: _vm.form[field.featureId].issueHelp,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "issueHelp",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form[field.featureId].issueHelp"
                                  }
                                },
                                [
                                  field.featureLink
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            slot: "activator",
                                            flat: "",
                                            icon: ""
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "help-btn" },
                                            [_vm._v("help")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-toolbar",
                                        { attrs: { card: "" } },
                                        [
                                          _c("v-toolbar-title", [
                                            _vm._v(
                                              "Help: " +
                                                _vm._s(field.featureName)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                right: "",
                                                color: ""
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.form[
                                                    field.featureId
                                                  ].issueHelp = false
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("close")])],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("iframe", {
                                        staticClass: "iframe__help",
                                        attrs: {
                                          id: field.featureId + "_frame",
                                          src: field.featureLink,
                                          width: "100%",
                                          height: "450px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _c("span", { staticClass: "resource-name py-1" }, [
                              _vm._v(_vm._s(field.featureName))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "resource-description pb-1" },
                              [_vm._v(_vm._s(field.featureDescription))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center px-2" },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  ref: field.featureId + "_status",
                                  refInFor: true,
                                  staticClass:
                                    "radio_group__feature_status pt-0",
                                  attrs: {
                                    name:
                                      "form[" + field.featureId + "_status]",
                                    rules: [
                                      function(v) {
                                        return v !== null || ""
                                      }
                                    ],
                                    row: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.form[field.featureId].status,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "form[field.featureId].status"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    staticClass:
                                      "radio__feature_status__working pl-2",
                                    attrs: { value: true, color: "success" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    staticClass:
                                      "radio__feature_status__broken pr-1",
                                    attrs: { value: false, color: "error" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-0",
                                  attrs: {
                                    color: "grey",
                                    flat: "",
                                    depressed: "",
                                    small: "",
                                    fab: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showDialog(
                                        _vm.form[field.featureId]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.form[field.featureId].issueDescription
                                    ? _c("v-icon", [_vm._v("insert_comment")])
                                    : _c("v-icon", [_vm._v("mode_comment")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.form[field.featureId].status !==
                                            true,
                                          expression:
                                            "form[field.featureId].status !== true"
                                        }
                                      ],
                                      staticClass: "error--text required-marker"
                                    },
                                    [_vm._v("•")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "", "max-width": "350" },
                                  model: {
                                    value:
                                      _vm.form[field.featureId].issueDialog,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "issueDialog",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form[field.featureId].issueDialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-text-field", {
                                            ref:
                                              field.featureId +
                                              "_issueDescription",
                                            refInFor: true,
                                            attrs: {
                                              name:
                                                "form[" +
                                                field.featureId +
                                                "_issueDescription]",
                                              label: "Issue Description",
                                              rules: [
                                                function(v) {
                                                  return (
                                                    Boolean(
                                                      _vm.form[field.featureId]
                                                        .status === true ||
                                                        (typeof v ===
                                                          "string" &&
                                                          v.length)
                                                    ) || "Required"
                                                  )
                                                },
                                                function(v) {
                                                  return (
                                                    v.length <= 140 ||
                                                    "Max 140 characters"
                                                  )
                                                }
                                              ],
                                              "multi-line": "",
                                              counter: 140
                                            },
                                            model: {
                                              value:
                                                _vm.form[field.featureId]
                                                  .issueDescription,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form[field.featureId],
                                                  "issueDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form[field.featureId].issueDescription"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("p", { staticClass: "py-2" }, [
                                            _vm._v(
                                              "Remember: This description will be visible to clients. Please keep all language clear and professional."
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "grey",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteIssueDialog(
                                                    _vm.form[field.featureId]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("delete")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "btn__text" },
                                                [_vm._v("Discard")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.saveIssueDialog(
                                                    _vm.form[field.featureId]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("save")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "btn__text" },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-center my-4" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn__submit_report",
                      attrs: { disabled: !_vm.formValid, color: "success" },
                      on: {
                        click: function($event) {
                          return _vm.submitReport()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("send")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "btn__text" }, [
                        _vm._v("Submit Report")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { persistent: "", "max-width": "350" },
                      model: {
                        value: _vm.thankYouDialog,
                        callback: function($$v) {
                          _vm.thankYouDialog = $$v
                        },
                        expression: "thankYouDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "headline",
                              attrs: { "primary-title": "" }
                            },
                            [_vm._v("Thank You!")]
                          ),
                          _vm._v(" "),
                          _c("v-card-text", [
                            _c("p", [
                              _vm._v(
                                "Thank you for reporting! Your report has been queued, and will be sent shortly."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "You may return to the Room Picker now, using the button below, or you will be redirected there automatically in " +
                                  _vm._s(_vm.roomPickerRedirectDelaySeconds) +
                                  " seconds."
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.goToRoomPicker()
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("forward")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "btn__text" }, [
                                      _vm._v("Back to Room Picker")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1d4164", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1d4164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report.vue
// module id = Ri3b
// module chunks = 1